import { memo } from 'react';
import { Flow } from '@thive/fddm-types';

import { NumberInput } from '@/modules/common/components/inputs';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { useOrderProfileStore } from '@/modules/orderProfile/store/useOrderProfileStore';

import { FlowGraph, LoadPerHourInput } from '.';
import { useFlowUpdaters } from '../hooks/useFlowUpdaters';

interface Props {
  id: string;
  disabled: boolean;
  flow: Flow;
}

function ExternalFlowProperties({ id, disabled, flow }: Props) {
  const { onProcessDurationChange } = useFlowUpdaters(id);
  const { hourlyOrderCounts, externalFlowExtension } = flow;
  const { orderProfile } = useOrderProfileStore();
  const totalNumLoads = hourlyOrderCounts[0];

  if (!externalFlowExtension) return null;

  const { processDuration } = externalFlowExtension;

  return (
    <>
      {orderProfile ? (
        <FlowGraph hourlyOrderCounts={hourlyOrderCounts} />
      ) : (
        <PropertiesLabel
          labelRatio={70}
          i18nkey='interface:properties.flows.flow_info.total_loads.label'
        >
          <LoadPerHourInput id={id} totalNumLoads={totalNumLoads} disabled />
        </PropertiesLabel>
      )}
      <PropertiesLabel
        labelRatio={70}
        i18nkey='interface:properties.flows.manual.fields.process_duration.label'
      >
        <NumberInput value={processDuration} minValue={0} onChange={onProcessDurationChange} />
      </PropertiesLabel>
    </>
  );
}

export default memo(ExternalFlowProperties);
